import Logo from '../../assets/images/Phoria-Logo_YBBG.png'
const Toast = ({ children, emoji, onDismiss }) => {
	return (
		<div className="flex items-center justify-between bg-secondary2 shadow-md py-2 md:py-4 pl-4 pr-8 md:px-12 space-x-4 rounded relative mt-3">
			<img alt="Phoria Logo" src={Logo} className="w-8 md:w-12 h-8 md:h-12 rounded-full flex-shrink-0" />
			<p className="font-bold text-sm md:text-lg text-white">{children}</p>
			<span>{emoji || '😊'}</span>
			<button onClick={onDismiss} className="absolute top-2 right-2 text-gray-300 hover:text-white">
				<i className="material-icons text-sm">close</i>
			</button>
		</div>
	)
}

export default Toast